import { useEffect, useState } from "react";
// import Tangram from "tangram";
import {
  LayersControl,
  MapContainer,
  TileLayer,
  ZoomControl,
} from "react-leaflet";
import L, { map } from "leaflet";
import { GestureHandling } from "leaflet-gesture-handling";
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";

// import CustomMapLayout from "./CustomMapLayout";
import MapEvents from "./MapEvents";
import Routing from "./Routing";
import FlyTo from "./FlyTo";
import InvalidateSize from "./invalidateSize";
import { getQueryParam, setQueryParam, deleteQueryParam } from "../Utils/utils";

export const Map = (props) => {
  const {
    filters,
    location,
    resetLocation,
    fetchRoutes,
    initMapZoom,
    redirectRoute,
    mapCenter,
    dictionary,
    isOverview,
    plannerHorseback,
    isMapView,
    onDetailStart,
    onDetailDone,
    currentSportType,
    isLoading
  } = props;

  const [mapElements, setMapElements] = useState([]);
  const [currentZoom, setCurrentZoom] = useState(initMapZoom);
  const [isComboroute, setIsComboRoute] = useState(false);
  const [hasLoadError, setHasLoadError] = useState(false);

  const handleRequestStart = () => {
    setHasLoadError(false);
    onDetailStart();
  };

  useEffect(() => {
    if (getQueryParam('combo') === 'true') {
      setIsComboRoute(true);
    }
  }, []);

  const GetMapElements = (data) => {
    setMapElements(data);
    fetchRoutes(data);
  };

  const getZoomLevel = (zoomLevel) => {
    setCurrentZoom(zoomLevel);
  };

  const handleOptionChange = () => {
    const newValue = !isComboroute;
    setIsComboRoute(newValue);
    if (newValue) {
      setQueryParam('combo', 'true');
    } else {
      deleteQueryParam('combo');
    }
  };

  L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);

  return (
    <MapContainer
      center={mapCenter}
      zoom={initMapZoom}
      minZoom={8.4}
      className="c-sportroute-map__container"
      zoomControl={false}
      gestureHandling={true}
      gestureHandlingText={{
        touch: dictionary.TouchGesture,
        scroll: dictionary.ScrollGesture,
        scrollMac: dictionary.MacScrollGesture,
      }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <LayersControl position="topright">
        <LayersControl.Overlay name={dictionary.satelietView}>
          <TileLayer
            url="https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
            maxZoom={20}
            subdomains={["mt1", "mt2", "mt3"]}
          />
        </LayersControl.Overlay>
      </LayersControl>

      <ZoomControl position="bottomright" />

      <MapEvents
        fetchMapElements={GetMapElements}
        filters={filters}
        getZoomLevel={getZoomLevel}
        isComboRoute={isComboroute}
        onRequestStart={handleRequestStart}
        onRequestDone={onDetailDone}
        onRequestError={() => setHasLoadError(true)}
    />
      {(isLoading || hasLoadError) && (
        <div
          className={`c-sportroute-map__status${
            hasLoadError ? " c-sportroute-map__status--error" : ""
          }`}
          aria-live="polite"
          role="status"
        >
          {isLoading && (
            <span
              className="c-sportroute-map__status-spinner"
              aria-hidden="true"
            />
          )}
          <span>
            {hasLoadError
              ? dictionary.kaartLadenMislukt || "Routes laden mislukt"
              : dictionary.kaartLaden || "Routes laden"}
          </span>
        </div>
      )}

      <FlyTo location={location} resetLocation={resetLocation} />
      <InvalidateSize isMapView={isMapView} />

      {mapElements.data !== undefined && (
        <>
          {currentSportType !== "kayak" && (
            <div className="c-sportroutes-combo-control__container">
              <div className="c-radio">
                <input
                  id="basic"
                  name="basic"
                  checked={isComboroute === false}
                  type="radio"
                  onChange={handleOptionChange}
                />
                <label htmlFor="basic">
                  {dictionary.verbergCombinatieRoutes}
                </label>
              </div>
              <div className="c-radio">
                <input
                  id="combo"
                  name="combo"
                  checked={isComboroute === true}
                  type="radio"
                  onChange={handleOptionChange}
                />
                <label htmlFor="combo">{dictionary.toonCombinatieRoutes}</label>
              </div>
            </div>
          )}

          {mapElements.data.routes &&
            mapElements.data.routes.map((route, index) => {
              return (
                <Routing
                  key={route.id}
                  route={route}
                  redirectRoute={redirectRoute}
                  isOverview={isOverview}
                  currentZoom={currentZoom}
                />
              );
            })}
        </>
      )}
    </MapContainer>
  );
};

export default Map;
